var map = {
	"./country-selection.de-CH.json": 1660,
	"./country-selection.de-DE.json": 1661,
	"./country-selection.en-CA.json": 1662,
	"./country-selection.en-GB.json": 1663,
	"./country-selection.en-IN.json": 1664,
	"./country-selection.en-ME.json": 1665,
	"./country-selection.en-US.json": 1666,
	"./country-selection.es-EM.json": 1667,
	"./country-selection.es-ES.json": 1668,
	"./country-selection.fr-BE.json": 1669,
	"./country-selection.fr-CA.json": 1670,
	"./country-selection.fr-CH.json": 1671,
	"./country-selection.nl-BE.json": 1672,
	"./country-selection.nl-NL.json": 1673,
	"./country-selection.pl-PL.json": 1674,
	"./country-selection.pt-BR.json": 1675
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1659;